import { ADT3DViewerCard } from '../../components/adt-3d-viewer-card/ADT3DViewerCard'

const Model3d = () => {
    return <ADT3DViewerCard />
}

export default Model3d